












import {Component, Vue} from 'vue-property-decorator';
import {
  Action,
  Getter,
} from 'vuex-class';
import Snackbar from '@/modules/common/snackbar/_components/Snackbar.vue';
import LoaderFullscreen from '@/modules/common/loader/_components/LoaderFullscreen.vue';

@Component({
  components: {LoaderFullscreen, Snackbar},
})
export default class AuthLayout extends Vue {
  @Action('map/startQuickCatchment') private startQuickCatchment!: any;
  @Action('map/stopQuickCatchment') private stopQuickCatchment!: any;
  @Action('common/loader/start') private startLoader!: any;
  @Action('common/loader/stop') private stopLoader!: any;

  @Getter('map/quickCatchment') private quickCatchment!: any;
  @Getter('auth/user') private user!: any;

  private triggerQuickCatchment() {
    // TODO: close all popups on the map
    if (!this.quickCatchment) {
      this.startQuickCatchment();
    } else {
      this.stopQuickCatchment();
    }
  }
}
